const ENV = "production";
const BASE_API_URL = "https://api.solutions.coinhouse.io";
export { BASE_API_URL, ENV };